// This file is auto-generated. To include assets for the lazyloader, just add your .js file to Assets/js/blocks/ and it will be included here.
const dynamicAssets = [{"assetKey":"test-typography-block"},{"assetKey":"test-theme-block"},{"assetKey":"test-icons-block"},{"assetKey":"test-cta"},{"assetKey":"site-header-block"},{"assetKey":"site-footer-block"},{"assetKey":"breadcrumbs"}];
const api = {
    dynamicAssets,
};
export default api;